export enum Common {
  TITLE = 'Opinico',
  JWT_TOKEN = 'jwt',
}
